import VideoTypes from '../../domain/VideoTypes';

export const getProgress = (content, continueWatchingIsActive, continueWatchingItems) => {
    if (
        continueWatchingIsActive &&
        (content.contentType === VideoTypes.EPISODE || content.contentType === VideoTypes.SINGLE)
    ) {
        let position = 0;

        if (content.progressFraction) {
            return content.progressFraction;
        } else if (content.savedPosition) {
            position = content.savedPosition;
        } else {
            const savedItem = (continueWatchingItems ? continueWatchingItems : []).find(
                (item) => item.videoId && item.videoId.startsWith(content.id)
            );
            position = savedItem && savedItem.position ? savedItem.position : 0;
        }

        return content.materialLength > 0 ? (position / content.materialLength) * 100 : 0;
    }

    return 0;
};
